import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { PrimeReactProvider, APIOptions, addLocale } from 'primereact/api';
import huLocale from 'primelocale/hu.json';
import dayjs from 'dayjs';

import { initializeApp } from 'firebase/app';
import { browserSessionPersistence, getAuth } from 'firebase/auth';
import { AuthProvider } from './contexts/AuthContext';

// Add Hungarian locale from primelocale
addLocale('hu', huLocale.hu);

const primeReactConfig: Partial<APIOptions> = {
  inputStyle: 'outlined',
  locale: 'hu'
};

dayjs.locale('hu');

// Firebase configuration
const firebaseConfig = {
  persistence: browserSessionPersistence,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PrimeReactProvider value={primeReactConfig}>
      <I18nextProvider i18n={i18n}>
        <AuthProvider auth={auth}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </I18nextProvider>
    </PrimeReactProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals.console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
